export enum RefundType {
  Partial,
  Full,
}
